import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '../utils/auth'
import LoginView from '../views/LoginView.vue'
import AdminLayout from '../layouts/AdminLayout.vue'
import DashboardView from '../views/DashboardView.vue'
import ProductListView from '../views/products/ProductListView.vue'
import CategoryListView from '../views/products/CategoryListView.vue'
import MediaLibraryView from '../views/media/MediaLibraryView.vue'
import PageSectionListView from '../views/pages/PageSectionListView.vue'
import InquiryListView from '../views/inquiries/InquiryListView.vue'
import CustomRequestListView from '../views/inquiries/CustomRequestListView.vue'
import CaseListView from '../views/cases/CaseListView.vue'
import ArticleListView from '../views/articles/ArticleListView.vue'
import SiteSettingsView from '../views/settings/SiteSettingsView.vue'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.VUE_APP_BASE_URL || '/',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: { public: true }
    },
    {
      path: '/',
      component: AdminLayout,
      redirect: '/dashboard',
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: DashboardView,
          meta: {
            title: '仪表盘 Dashboard',
            menu: 'dashboard'
          }
        },
        {
          path: 'products',
          name: 'products',
          component: ProductListView,
          meta: {
            title: '产品 Products',
            menu: 'products'
          }
        },
        {
          path: 'categories',
          name: 'categories',
          component: CategoryListView,
          meta: {
            title: '产品分类 Product Categories',
            menu: 'categories'
          }
        },
        {
          path: 'page-sections',
          name: 'pageSections',
          component: PageSectionListView,
          meta: {
            title: '页面内容 Page Sections',
            menu: 'pageSections'
          }
        },
        {
          path: 'cases',
          name: 'cases',
          component: CaseListView,
          meta: {
            title: '案例 Cases',
            menu: 'cases'
          }
        },
        {
          path: 'articles',
          name: 'articles',
          component: ArticleListView,
          meta: {
            title: '文章 Articles',
            menu: 'articles'
          }
        },
        {
          path: 'inquiries',
          name: 'inquiries',
          component: InquiryListView,
          meta: {
            title: '询盘 Inquiries',
            menu: 'inquiries'
          }
        },
        {
          path: 'custom-requests',
          name: 'customRequests',
          component: CustomRequestListView,
          meta: {
            title: '定制请求 Custom Requests',
            menu: 'customRequests'
          }
        },
        {
          path: 'media',
          name: 'media',
          component: MediaLibraryView,
          meta: {
            title: '媒体库 Media Library',
            menu: 'media'
          }
        },
        {
          path: 'settings',
          name: 'settings',
          component: SiteSettingsView,
          meta: {
            title: '站点设置 Site Settings',
            menu: 'settings'
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const token = getToken()

  if (to.meta.public) {
    if (to.path === '/login' && token) {
      return next('/dashboard')
    }
    return next()
  }

  if (!token) {
    return next('/login')
  }

  return next()
})

export default router
